import parser from "accept-language-parser";
import { useRootStore } from "@/stores/root";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const rootStore = useRootStore();

  const headers = useRequestHeaders(["host"]);
  rootStore.setHost(process.client ? window.location.origin : headers.host);

  if (!isValidLocale(to.params.locale)) {
    let detectedLanguage = "en";
    let bebceLocale = useCookie("bebce_locale", { maxAge: 60 * 60 * 24 * 365 });
    if (bebceLocale.value) {
      detectedLanguage = bebceLocale.value;
    } else {
      const acceptLanguage = useRequestHeaders(["accept-language"]);
      const detectedLanguages = parseLanguages(
        acceptLanguage["accept-language"]
      );
      for (let i = 0; i < detectedLanguages.length; i++) {
        if (isValidLocale(detectedLanguages[i].code)) {
          detectedLanguage = detectedLanguages[i].code;
          break;
        }
      }
    }

    // TEMPORARY DISABLE KOREAN AND JAPANESE AND REDIRECT TO ENGLISH
    if (detectedLanguage === "ko" || detectedLanguage === "ja") {
      detectedLanguage = "en";
    }

    const redirectURL = getRedirectURL(detectedLanguage);
    if (to.fullPath != redirectURL) {
      bebceLocale.value = detectedLanguage;
      return navigateTo(getRedirectURL(detectedLanguage), {
        redirectCode: 301,
      });
    }
  }
  function isValidLocale(locale) {
    return /^it$|^en$|^en-u s$|^fr$|^de$|^es$|^ko$|^ja$/.test(locale);
  }
  function parseLanguages(languageHeader) {
    return parser.parse(languageHeader);
  }
  function getRedirectURL(lang) {
    if (to.params.locale && !isValidLocale(to.params.locale)) {
      return to.fullPath.replace(to.params.locale, lang);
    }
    return `/${lang}`;
  }
});
